import { render } from "./table-nilai-quiz.vue?vue&type=template&id=1c190bcf"
import script from "./table-nilai-quiz.vue?vue&type=script&lang=js"
export * from "./table-nilai-quiz.vue?vue&type=script&lang=js"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__